import type { Colors, DefaultTheme } from 'styled-components';
import { mapDarkTheme } from './DarkTheme';

const colors: Colors = {
  primary: {
    lighten: '#ffaf6f',
    default: '#ff933c',
    dim: 'rgba(255,147,60,0.4)',
    mute: 'rgba(255,147,60,0.1)',
  },
  gray: {
    '100': '#ffe',
    '000': '#030304',
    '010': '#0a0a0b',
    main: '#181A22',
    '020': '#25272e',
    '030': '#33353a',
    '040': '#414346',
    '050': '#484a4c',
    '060': '#515355',
    '070': '#616363',
    '080': '#8b8c88',
    '090': '#abaca4',
  },
  green: {
    lighten: '#23d255',
    default: '#1ca643',
    dim: 'rgba(28,166,67,0.4)',
    mute: 'rgba(28,166,67,0.1)',
  },
  red: {
    lighten: '#ff0943',
    default: '#d50032',
    dim: 'rgba(213,0,50,0.4)',
    mute: 'rgba(213,0,50,0.1)',
  },
  yellow: {
    lighten: '#d7bd66',
    default: '#CCAC3E',
    dim: 'rgba(204,172,62,0.4)',
    mute: 'rgba(204,172,62,0.1)',
  },
  orange: {
    lighten: '#ff6c1a',
    default: '#e65200',
    dim: 'rgba(230,82,0,0.4)',
    mute: 'rgba(230,82,0,0.1)',
  },
  blue: {
    lighten: '#61a8f0',
    default: '#338EEB',
    dim: 'rgba(51,142,235,0.4)',
    mute: 'rgba(51,142,235,0.1)',
  },
  purple: {
    lighten: '#a778e2',
    default: '#8B4ED9',
  },
  white: {
    default: '#ffffff',
    dim: 'rgba(255,255,255,0.4)',
    mute: 'rgba(255,255,255,0.1)',
  },
  black: {
    default: '#5a1c00',
    dim: 'rgba(90,28,0,0.4)',
    mute: 'rgba(90,28,0,0.1)',
  },
};

export const DarkAbsaTheme: DefaultTheme = mapDarkTheme(colors, {
  name: 'DarkABS',
});
